import { combineReducers } from 'redux';
import updateAdditionalDrivers from './ducks/updateAdditionalDrivers.duck';
import deleteAdditionalDrivers from './ducks/deleteAdditionalDriver.duck';

export default combineReducers({
    updateAdditionalDrivers,
    deleteAdditionalDrivers,
});
